import { getSessionUser } from '../../src/utilities/session.js'
import { toast } from '../../src/utilities/toast.js'
import { go } from './router-mixin.js'
import routes from './routes.js'

/** @type {PermissionCheck} */
export function userIsLoggedIn(options) {
  const isLoggedIn = !!options.sessionUser?.email

  if (!isLoggedIn) {
    toast('Please log in to view this page.')
    return routes.LOGIN
  }

  return null
}

/** @type {PermissionCheck} */
export function userIsVerified() {
  try {
    // @ts-ignore
    const status = getSessionUser().kyc_status
  } catch (e) {
    return routes.LOGIN
  }
  //TODO: Reverse this...
  // if (status == 'approved') {
  //   toast('Please verify your account to view this page.')
  //   return routes.NOT_VERIFIED
  // }

  return null
}

// TODO: Implement this permission check
// /** @type {AsyncPermissionCheck} */
// export async function WalletIsVerified(options) {
//   const isVerified = await getWalletVerificationStatus(options.sessionUser.userId)
//   console.log(isVerified)
//   if (!isVerified) {
//     toast('Please verify your wallet to view this page.')
//     return routes.DASHBOARD
//   }
//   return null
// }

/** @type {PermissionCheck} */
export function userIsAdmin(options) {
  return options?.sessionUser?.user?.kind === 'Administrator'
    ? null
    : routes.LOGIN
}

/** @type {PermissionCheck} */
export function userIsCompliance(options) {
  // Based on web3 wallet not session user
  // return !!options.sessionUser?.id
  return null
}

/** @type {PermissionCheck} */
export function web3Connected(options) {
  const accountSelected = !!options.globals?.selectedAccount

  if (!accountSelected) {
    toast('Please select a wallet account to view this page.')
    return routes.DASHBOARD
  }
  return null
}

/** @type {PermissionCheck} */
export function userHasKipRole(options) {
  const kipRoles = options.kipRoles
  if (!kipRoles || kipRoles.length === 0) {
    toast('You need KIP roles to access this page.')
    go(routes.DASHBOARD.path)
  }
  return null
}
